import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/eds-icon';
import './SubscriptionTools.scss';
import {
    Clipboard,
    HandWithMoney,
    Megaphone,
    Ticket,
    Trending,
} from '@eventbrite/eds-iconography';

const SUBSCRIPTION_TOOLS = [
    {
        icon: <Ticket />,
        headerText: gettext('Easy ticketing'),
        listItems: [
            gettext('Multiple ticket types'),
            gettext('Customizable event pages'),
            gettext('Ticket transfers'),
            gettext('Custom order forms'),
            gettext('Custom URLs'),
        ],
    },
    {
        icon: <Megaphone />,
        headerText: gettext('Marketing tools'),
        listItems: [
            gettext('Email marketing'),
            gettext('Social sharing'),
            gettext('Paid social ads'),
            gettext('Eventbrite Ads'),
            gettext('Promo codes'),
        ],
    },
    {
        icon: <Trending />,
        headerText: gettext('Data insights'),
        listItems: [
            gettext('Sales dashboards'),
            gettext('Traffic and conversion report'),
            gettext('Smart audiences'),
        ],
    },
    {
        icon: <Clipboard />,
        headerText: gettext('Event management'),
        listItems: [
            gettext('Organizer app'),
            gettext('Attendee check-in'),
            gettext('Waitlists'),
            gettext('Team permissions'),
        ],
    },
    {
        icon: <HandWithMoney />,
        headerText: gettext('Secure payments'),
        listItems: [
            gettext('Payment processing'),
            gettext('Embedded checkout on your own website'),
            gettext('Payouts before your event'),
        ],
    },
];

export const SubscriptionTool = ({ icon, headerText, listItems }) => {
    return (
        <div className="pricing-and-packaging-subscription-tool">
            <div className="tool-icon">
                <Icon type={icon} strokeColor="ui-orange" size="small" />
            </div>
            <div className="tool-info">
                <h2 className="tool-header">{headerText}</h2>
                <ul className="tool-list">
                    {listItems.map((text, i) => (
                        <li key={i}>{`• ${text}`}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export const SubscriptionTools = () => {
    return (
        <>
            <h2 className="subscription-tools-header">
                {gettext('Every organizer gets these powerful tools')}
            </h2>
            <div className="pricing-and-packaging-tools">
                {SUBSCRIPTION_TOOLS.map((toolProps, i) => (
                    <SubscriptionTool key={i} {...toolProps} />
                ))}
            </div>
        </>
    );
};

export default SubscriptionTools;
